import React from "react";
import { bool, func } from "prop-types";

import { useTranslation } from "@lib/i18n";

import Popin from "@components/shared/Popin";

const ConfirmationModal = ({ isOpen, onClose, onConfirm }) => {
  const { t } = useTranslation();

  const translationValue = t(`customize.confirmationDialog.body`, {
    returnObjects: true,
  });

  const paragraphs = Array.isArray(translationValue) ? translationValue : [];

  if (!isOpen) {
    return null;
  }

  return (
    <Popin
      confirmTitle={t("general.accept")}
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      preventConfirmBeforeScroll
      title={t("customize.confirmationDialog.title")}
      withCloseIcon
    >
      <div className="flex flex-col gap-4">
        {paragraphs.map((paragraph, i) => (
          <div key={i}>
            <p className="text-xl font-semibold">{paragraph.heading}</p>
            {paragraph.text}
          </div>
        ))}
      </div>
    </Popin>
  );
};

ConfirmationModal.propTypes = {
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  onConfirm: func.isRequired,
};

export default ConfirmationModal;
